<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
 name:'APP',
data(){
			return{
				
			}
		}
  
};
</script>
<style>

</style>

